import { getCrossBorderOrders } from "@client-shared/services/api/orders";
import { useQuery } from "@tanstack/react-query";
import { AdminCrossBorderView } from "../components/views/admin-cross-border-view";

const CROSS_BORDER_QUERY_KEY = ["cross-border-orders"] as const;
const POLLING_INTERVAL = 60_000;

export function AdminCrossBorderPage() {
  const { data, isLoading, isError, dataUpdatedAt } = useQuery({
    queryKey: CROSS_BORDER_QUERY_KEY,
    queryFn: ({ signal }) => getCrossBorderOrders({}, signal),
    refetchInterval: POLLING_INTERVAL,
  });

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-6">
      <AdminCrossBorderView
        orders={data?.orders ?? []}
        analytics={data?.analytics}
        isLoading={isLoading}
        isError={isError}
        lastUpdatedAt={dataUpdatedAt ? new Date(dataUpdatedAt) : undefined}
      />
    </div>
  );
}
